<div
  class="modal fade"
  #documentViewerModal
  tabindex="-1"
  aria-labelledby="documentViewerModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-xl modal-dialog-centered modal-fullscreen-sm-down">
    <div class="modal-content shadow-lg">
      <div class="modal-header">
        <h5 class="modal-title" id="documentViewerModalLabel">
          {{ state.document?.name || 'Document preview' }}
        </h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
      </div>
      <div class="modal-body p-0">
        <ng-container *ngIf="!state.error; else errorTemplate">
          <div
            *ngIf="!state.contentUrl"
            class="document-viewer-loading d-flex justify-content-center align-items-center py-5"
          >
            <div class="text-center">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
          <div *ngIf="state.isImage && state.contentUrl" class="document-viewer-image-wrapper p-3">
            <img
              [src]="state.contentUrl"
              [alt]="state.document?.name || 'Document image'"
              class="img-fluid document-viewer-image"
            />
          </div>
          <iframe
            *ngIf="!state.isImage && state.contentUrl"
            class="document-viewer-iframe"
            sandbox="allow-scripts"
            referrerpolicy="no-referrer"
            [src]="state.contentUrl"
            title="Document preview"
          ></iframe>
        </ng-container>
        <ng-template #errorTemplate>
          <div class="p-4">
            <div class="alert alert-warning mb-0">
              {{ state.error }}
            </div>
          </div>
        </ng-template>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="close()">Close</button>
        <button
          type="button"
          class="btn btn-primary"
          *ngIf="state.document && !state.error"
          (click)="download(state.document)"
        >
          Download
        </button>
      </div>
    </div>
  </div>
</div>
